import { Extension } from "@tiptap/core";
import "@tiptap/extension-text-style";
export const SpanClass = Extension.create({
    name: "spanClass",
    addOptions: {
        types: ["textStyle"]
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    spanClass: {
                        default: "none",
                        renderHTML: (attributes) => {
                            if (!attributes.spanClass) {
                                return {};
                            }
                            return {
                                class: attributes.spanClass
                            };
                        },
                        parseHTML: (element) => ({
                            spanClass: element.classList.value,
                        })
                    }
                }
            }
        ];
    },
    addCommands() {
        return {
            toggleSpanClass: (spanClass) => ({ editor, chain }) => {
                console.log(editor)

                if (!editor.isActive('textStyle')) {
                    return chain().setMark('textStyle', { spanClass }).run()
                } else {
                    let textStyleClasses = editor.getAttributes('textStyle').spanClass.split(' ')

                    if ((textStyleClasses).includes(spanClass)) {
                        textStyleClasses = textStyleClasses.filter(className => className !== spanClass)
                    } else {
                        textStyleClasses.push(spanClass)
                    }

                    if (textStyleClasses.length) {
                        return chain().setMark('textStyle', { spanClass: textStyleClasses.join(' ') }).run()
                    } else {
                        return chain().setMark("textStyle", { spanClass: "" })
                            .removeEmptyTextStyle()
                            .run()
                    }
                }
            },
        }
    }
    // addCommands() {
    //     return {
    //         setSpanClass: (spanClass) => ({ chain }) => {
    //             return chain().setMark("textStyle", { spanClass }).run();
    //         },
    //         unsetSpanClass: () => ({ chain }) => {
    //             return chain()
    //                 .setMark("textStyle", { spanClass: "" })
    //                 .removeEmptyTextStyle()
    //                 .run();
    //         }
    //     };
    // }
});
